import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {Log} from "ng2-logger";
import * as FileSaver from "file-saver";
import {Tool} from "@app/tool/model/tool.model";
import * as _ from 'lodash';

import {ToolService} from "app/core/services/tool.service";

import {TableConfig} from "@app/shared/util/table-config.utils";
import {HttpResponse} from '@angular/common/http';
import {Router} from "@angular/router";
import {PermissionService} from '@app/authentication/services/permission.service';

@Component({
    selector: 'app-tool-interventions',
    templateUrl: './tool-interventions.component.html',
    styleUrls: ['./tool-interventions.component.scss']
})
export class SpecificToolInterventionsComponent implements OnInit, OnDestroy {
    private _logger = Log.create(SpecificToolInterventionsComponent.name);

    selectedTool: Tool;
    subscription: Subscription;
    isLoading = false;
    tableConfig = new TableConfig();

    constructor(
        private toolService: ToolService,
        private router: Router,
        private permissionService: PermissionService
    ) {
        this.subscribeToToolChanges();
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    private subscribeToToolChanges() {
        this._logger.info('subscribeToToolChanges:: Subscribing to toolsSelected$');
        this.subscription = this.toolService.toolSelectedAsObservable.subscribe(
            (tool) => {
                this.selectedTool = tool;
                if (this.selectedTool && this.selectedTool.id) {
                    this.getToolInterventions(this.selectedTool.id);
                }
            },
            (error) => {
                this._logger.error('subscribeToToolChanges:: Subscriber error', error);
            }
        )
    }

    private getToolInterventions(id: number, tableConfig = new TableConfig()) {
        this._logger.info('getToolInterventions:: Retrieving interventions for [selectedTool,tableConfig]',
            this.selectedTool, this.tableConfig);
        this.isLoading = true;
        this.toolService.getInterventionsForTool(id, tableConfig)
            .subscribe(
                data => {
                    this._logger.info('API Returned data', data);
                    this.selectedTool.interventions = data.items;
                    this.tableConfig.pager.count = data.total;
                    this.isLoading = false;
                },
                error => {
                    this._logger.error('API Returned error', error);
                }
            )
    }

    onTableRowClick(intervention) {
        if (!this.canOpenTicketDetails()) {
            return;
        }

        this._logger.info("onTableRowClick::", intervention);
        const url = !intervention.operationHasTask
            ? this.router.createUrlTree(
                [`/ticket-management/${intervention["ticketId"]}`])
            : this.router.createUrlTree(
                [`/ticket-management/${intervention["ticketId"]}/activities/${intervention.operationType.id}/details`],
                {queryParams: {toolId: this.selectedTool.id}});

        localStorage.setItem('openedInNewTab', 'true');
        window.open(url.toString());
    }

    onDownloadExcelFile() {
        const exportConfig = _.cloneDeep(this.tableConfig);
        exportConfig.pager.pageSize = -1;
        this.toolService.downloadToolInterventionReport(this.selectedTool.id, exportConfig)
            .subscribe((data: HttpResponse<any>) => {
                if (data.body != null) {
                    this._logger.info('onDownloadToolReport:: API Returned error', data);
                    const blob = new Blob([data.body], {type: 'application/xsls'});
                    const filename = data.headers.get('x-filename');
                    FileSaver.saveAs(blob, filename);
                }
            },
            (error: any) => {
                this._logger.error('onDownloadToolReport:: API Returned error', error);
            });
    }

    onSortChange(event) {
        this._logger.info("onSortChange::", event);
        this.getToolInterventions(this.selectedTool.id, this.tableConfig);
    }

    onFilter(event) {
        this._logger.info("onFilter::", event);
        this.getToolInterventions(this.selectedTool.id, this.tableConfig);
    }

    onPageChange(event) {
        this._logger.info("onPageChange::", event);
        this.getToolInterventions(this.selectedTool.id, this.tableConfig);
    }

    canOpenTicketDetails(): boolean {
        return this.permissionService.hasHasPermissionForFeature('VIEW_TICKETS');
    }

}
